<section class="hero">
  <app-showcase
    [blockImage]="blockHelper.filterBlocksByKey(blocks, 'contact')"
    fxHide
    fxShow.gt-sm
  ></app-showcase>

  <div class="hero-card pb-2" fxLayout="column wrap" fxLayoutGap="2%">
    <div
      class="card-header pb-2"
      fxLayoutAlign="start center"
      fxLayoutGap="15px"
    >
      <img src="/assets/png/logo.png" alt="logo" />
      <div>
        <h1>Real Sol</h1>
      </div>
    </div>
    <address class="card-body">
      <a
        target="_blank"
        href="https://maps.app.goo.gl/gKy46vcaPBBn3C4E7"
        style="white-space: pre-wrap; font-weight: bold"
      >
        Grace Garden Residence
      </a>
      <a
        target="_blank"
        href="https://maps.app.goo.gl/gKy46vcaPBBn3C4E7"
        style="white-space: pre-wrap"
      >
        Str Erou Iancu Nicolae nr. 51, Vila 2
      </a>
      <a
        target="_blank"
        [href]="
          'tel:' +
          blockHelper.filterBlocksByKey(blocks, 'contact').properties.phone
        "
      >
        {{ blockHelper.filterBlocksByKey(blocks, "contact").properties.phone }}
      </a>
      <a
        target="_blank"
        [href]="
          'mailto:' +
          blockHelper.filterBlocksByKey(blocks, 'contact').properties.email
        "
      >
        {{ blockHelper.filterBlocksByKey(blocks, "contact").properties.email }}
      </a>
      <div class="social">
        Social Media
        <br />
        <br />

        <a href="https://www.facebook.com/realsolmanagement/" target="_blank">
          <img src="/assets/svg/facebook-green.svg" alt="FB" />
        </a>
        <a href="https://www.instagram.com/real_sol_services/" target="_blank">
          <img src="/assets/svg/instagram-green.png" alt="IG" />
        </a>
        <a
          href="https://www.linkedin.com/company/realsolrealestate/"
          target="_blank"
        >
          <img src="/assets/svg/linkedin-green.svg" alt="LinkedIn" />
        </a>
      </div>
    </address>
  </div>
</section>

<section class="inquiry-page pt-5">
  <div class="container">
    <div class="inquiry-header">
      <h1 class="special-letter-wrapper">{{ "Contact" | translate }}</h1>
    </div>

    <app-contact-form-base> </app-contact-form-base>
  </div>

  <iframe
    class="gmaps"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1422.565051181124!2d26.12876242257997!3d44.5124884707661!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b202b016116ff5%3A0xa6c68b9fed127a51!2sComplex%20rezidential%20Grace%20Garden!5e0!3m2!1sro!2sro!4v1746622406377!5m2!1sro!2sro"
    width="800"
    height="600"
    style="border: 0"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
  >
  </iframe>
</section>
